import { render, staticRenderFns } from "./SurveySplash.vue?vue&type=template&id=cafda8f4&scoped=true&"
import script from "./SurveySplash.vue?vue&type=script&lang=js&"
export * from "./SurveySplash.vue?vue&type=script&lang=js&"
import style0 from "./SurveySplash.vue?vue&type=style&index=0&id=cafda8f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cafda8f4",
  null
  
)

export default component.exports